// opervex-frontend/src/Opervex/Accounting/Branches.js

class Branches {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findAll() {
    return await this.#_api.get("/Accounting/Branches");
  }

  async findId(id) {
    return this.#_api.get("/Accounting/Branches/" + id);
  }

  async update(id, data) {
    return this.#_api.put("/Accounting/Branches/" + id, data);
  }

  async create(data) {
    return this.#_api.post("/Accounting/Branches/", data);
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "cnpj",
        label: "CNPJ",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "resale",
        label: "Revenda",
        type: "boolean",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Branches;
